









































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import _ from "lodash";
import appconst from "./../../lib/appconst";

@Component
export default class Notice extends AbpBase {
  noticeSpinShow: boolean = true;
  get noticeList(): Array<any> {
    return this.$store.state.app.noticeList;
  }
  get unReadCount() {
    return this.$store.state.app.noticeUnreadTotalCount;
  }
  get noticeArray() {
    return _.isNil(this.noticeList)
      ? []
      : this.noticeList.filter((n) => n.read == false && n.severity === 0);
  }
  get noticeCount() {
    return _.isNil(this.noticeList)
      ? 0
      : this.noticeList.filter((n) => n.read == false && n.severity === 0)
          .length;
  }
  get noticeLabel() {
    let name = this.L("Notice");
    if (this.noticeCount > 0) {
      return `${name}`;
    } else {
      return name;
    }
  }
  getNotices() {
    setTimeout(() => {
      this.noticeSpinShow = false;
    }, 2000);
  }
  onClickNotice(notice) {
    var notification = _.find(this.noticeList, ["id", notice.id]);
    if (_.isNil(notification) || _.isNil(notification.data)) return;
    switch (notification.data.notificationType) {
      case appconst.notificationObjectTypes.SOR_APPROVED:
        window.open(
          `/#/operations/view/saleorder-request/${notice.data.objectId}`,
          "_blank"
        );
        break;
      case appconst.notificationObjectTypes.SO_CREATED:
        window.open(
          `/#/operations/view/saleorder/${notice.data.objectCode}`,
          "_blank"
        );
        break;
      case appconst.notificationObjectTypes.PO_CREATED:
      case appconst.notificationObjectTypes.PO_CRM_RO_CREATED:
      case appconst.notificationObjectTypes.PO_RO_CREATED:
      case appconst.notificationObjectTypes.PO_CNL_AF_PACK_CREATED:
      case appconst.notificationObjectTypes.PO_SHIP_CREATED:
      case appconst.notificationObjectTypes.PO_TRSFR_CREATED:
        window.open(
          `/#/operations/view/purchaseorder/${notice.data.objectCode}`,
          "_blank"
        );
        break;
    }
    notification.read = true;
    this.$store.dispatch({
      type: "user/changeNotificationToRead",
      data: { id: notification.id },
    });
    this.$store.commit({
      type: "app/decreaseNoticeUnreadTotalCount",
      data: 1,
    });
  }
}
